import { render, staticRenderFns } from "./BgFormTags.vue?vue&type=template&id=34f1f7f2"
import script from "./BgFormTags.vue?vue&type=script&lang=js"
export * from "./BgFormTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports